module.exports = __webpack_public_path__ + "static/media/s_sf_14.2d882267.png";